if ("function" != typeof ScrollingText) {
  class t extends HTMLElement {
    constructor() {
      super();
      var t = (function () {
        function t(t) {
          var i = t.getBoundingClientRect();
          return i.right - i.left;
        }
        function i(i, n) {
          var e = (i.children && i.children[0]) || null;
          if (!e) throw "No child node found";
          (e.style.position = "relative"),
            (this.position = 0),
            (this.speed = n),
            (this.box_width = t(i)),
            (this.inner_element_width = t(e)),
            (this.box = i),
            (this.inner_element = e.cloneNode(!0)),
            s.call(this);
        }
        function n() {
          (this.box_width = t(this.box)),
            (this.inner_element_width = t(this.box.children[0]));
        }
        function e() {
          return Math.ceil(this.box_width / this.inner_element_width) + 1;
        }
        function s() {
          var t = e.call(this);
          if (t > this.box.children.length)
            for (var i = this.box.children.length; i < t; i++)
              this.box.appendChild(this.inner_element.cloneNode(!0));
          else if (t < this.box.children.length)
            for (var i = t; i < this.box.children.length; i++)
              this.box.removeChild(this.box.lastChild);
        }
        function o(t, i) {
          var e = this;
          n.call(this),
            s.call(this),
            Array.prototype.forEach.call(this.box.children, function (t) {
              "rtl" == i
                ? (t.style.transform = `translateX(${e.position}px)`)
                : (t.style.transform = `translateX(${-e.position}px)`);
            }),
            (this.position += (this.speed * t) / 1e3),
            this.position >= this.inner_element_width &&
              (this.position = this.position % this.inner_element_width);
        }
        return (
          (i.prototype = {
            start: function (t, i) {
              this._running = !0;
              var n = this,
                e = null,
                s = function () {
                  if (n._running) {
                    var r = Date.now(),
                      h = null === e ? 0 : r - e;
                    o.call(n, h, t, i),
                      (e = r),
                      window.requestAnimationFrame(s);
                  }
                };
              window.requestAnimationFrame(s);
            },
            stop: function () {
              this._running = !1;
            },
          }),
          i
        );
      })();
      let i =
          window.innerWidth > 768
            ? parseInt(this.dataset.scrollingSpeed)
            : parseInt(this.dataset.scrollingSpeed) / 2.5,
        n = this.dataset.scrollingDirection,
        e = new t(this, i, n);
      if ("true" == this.dataset.pauseOnHover) {
        let s = function () {
            l && e.stop();
          },
          o = function () {
            l && e.start(n);
          };
        var r = s,
          h = o;
        let l = !0;
        window.addEventListener("blur", function () {
          l = !1;
        }),
          window.addEventListener("focus", function () {
            l = !0;
          }),
          this.addEventListener("mouseover", s),
          this.addEventListener("mouseout", o);
      }
      new IntersectionObserver((t) => {
        t[0].isIntersecting ? e.start(n) : e.stop();
      }).observe(this);
    }
  }
  typeof customElements.get("scrolling-text") > "u" &&
    customElements.define("scrolling-text", t);
}
